import { areObjectsEqual } from "./Compare";

export const getNewEntitiesIds = (
  original: any[],
  entities: any[],
  idField: string,
) => {
  const newEntities = entities.filter(
    (entity) => !original.some((orig) => orig[idField] === entity[idField]),
  );
  return newEntities.map((entity) => entity[idField]);
};

export const getRemovedEntitiesRelationIds = (
  original: any[],
  entities: any[],
  relationData: any[],
  idField: string,
  relationIdField: string | null = null,
  relationField: string | null = null,
) => {
  const removedEntities = original.filter(
    (orig) => !entities.some((entity) => entity[idField] === orig[idField]),
  );
  if (relationField === null || relationIdField === null) {
    return removedEntities.map((entity) => entity[idField]);
  }
  const removedRelationIds = relationData
    ?.filter((relation: { [l: string]: any }) =>
      removedEntities.some(
        (entityRemoved) =>
          entityRemoved[idField] === relation[relationField][idField],
      ),
    )
    .map((relation) => relation[relationIdField]);
  return removedRelationIds || [];
};

export const getEditedEntitiesList = (
  original: any[],
  entities: any[],
  idField: string,
) => {
  const editedEntities = entities.filter((entity) =>
    original.some((orig) =>
      orig[idField] === entity[idField]
        ? !areObjectsEqual(orig, entity)
        : false,
    ),
  );
  return editedEntities;
};
